import cacheMeta from './cacheMeta';
import { combineReducers } from 'redux';
import geo from './geo.reducer';
import session from './session.reducer';
import tours from './tours.reducer';

const reducers = {
    tours,
    session,
};

let caching_reducers = {
    geo,
};

caching_reducers = Object.keys(caching_reducers).reduce((acc, key) => {
    acc[key] = cacheMeta(caching_reducers[key]);
    return acc;
}, {});

export default combineReducers({ ...reducers, ...caching_reducers });
